import loadjs from "loadjs";

window.loadjs = loadjs;

const u = window.navigator.userAgent;
const isIE = u.indexOf("MSIE") > -1 || u.indexOf("Trident") > -1;
const IEVersion = u
  .replace(/^.*MSIE ([\d.]+).*$/, "$1")
  .replace(/^.*rv:([\d.]+).*$/, "$1");

if (isIE && parseInt(IEVersion, 10) === 9) {
  const version = localStorage.staticVersion || new Date().getTime();
  loadjs(
    [
      `css!/cloudstore/resource/pc/com/v1/index.min-1.css?v=${version}`,
      `css!/cloudstore/resource/pc/com/v1/index.min-2.css?v=${version}`,
      `css!/cloudstore/resource/pc/com/v1/ecCom.min-1.css?v=${version}`,
      `css!/cloudstore/resource/pc/com/v1/ecCom.min-2.css?v=${version}`
    ],
    "ie9CSSSpit"
  );
}



// WEBPACK FOOTER //
// ./loadCssSpit.js